<template>
	<header class="marketing-hero align-items-center bg-color-content-primary position-relative">
		<div class="coterminous" :style="{ background: backgroundStyle }"></div>
		<div class="container">
			<div class="col-12 col-7-md text-align-center position-relative">
				<p class="overline text-color-gold-light">Fundrise Pro</p>
				<h1 class="heading-xl text-color-white mt-100 ml-auto mr-auto">Take control of your portfolio</h1>
				<p class="delta text-color-white mt-150 mt-100-md"
					>Fine-tune your investment strategy with a custom portfolio and enjoy priority access to strategy
					specific investment funds for $10/month.
				</p>
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const backgroundImage = computed((): string => {
	return (
		appCloudfrontPath +
		(appStore.isMobile
			? '/images/marketing-site/running-man-tall.png'
			: '/images/marketing-site/running-man-wide.png')
	);
});

const backgroundStyle = computed((): string => {
	const mobileStyle = 'center bottom / 100% no-repeat';
	const desktopStyle = '50% 50% / cover no-repeat';
	return `url(${backgroundImage.value}) ${appStore.isMobile ? mobileStyle : desktopStyle}`;
});
</script>
<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;
.lead-capture {
	@include respond-to(md) {
		max-width: 516px;
	}
}
.marketing-hero {
	min-height: 670px;
	padding-top: 8rem;
	@include respond-to(md) {
		min-height: 640px;
		padding-top: 11rem;
	}
}
</style>
